"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class PhysicalGateway extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'physicalGateway';
        this._resetOwners = initParams.reset_owners;
        this._serialNumber = initParams.serial_number;
        this._installationCode = initParams.installation_code;
        this._owners = (0, util_1.camelArray)(initParams.owners);
    }
    set resetOwners(value) {
        console.error('Do not set objects this way');
    }
    setResetOwners(value) {
        return this.dataService.updatePhysicalGateway(this.id, { reset_owners: value }, this);
    }
    get resetOwners() {
        return this._resetOwners;
    }
    set serialNumber(value) {
        console.error('Do not set objects this way');
    }
    setSerialNumber(value) {
        return this.dataService.updatePhysicalGateway(this.id, { serial_number: value }, this);
    }
    get serialNumber() {
        return this._serialNumber;
    }
    set installationCode(value) {
        console.error('Do not set objects this way');
    }
    setInstallationCode(value) {
        return this.dataService.updatePhysicalGateway(this.id, { installation_code: value }, this);
    }
    get installationCode() {
        return this._installationCode;
    }
    set owners(value) {
        console.error('Do not set objects this way');
    }
    setOwners(value) {
        return this.dataService.updatePhysicalGateway(this.id, { owners: (0, util_1.snakeArray)(value) }, this);
    }
    get owners() {
        return this._owners;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updatePhysicalGateway(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = PhysicalGateway;
//# sourceMappingURL=physicalGateway.js.map